import { createHttpEndpoint } from '../../utils'

import type { GetBackboxInfoResponse } from './backbox.types'

export const getBackboxInfo = createHttpEndpoint<GetBackboxInfoResponse>({
  method: 'GET',
  operationId: 'getBackboxInfo',
  path: '/api/seller-experience/listings/backbox',
})
